import { render, staticRenderFns } from "./GlobalDiscounts.vue?vue&type=template&id=5f6fced0"
import script from "./GlobalDiscounts.vue?vue&type=script&lang=js"
export * from "./GlobalDiscounts.vue?vue&type=script&lang=js"
import style0 from "./GlobalDiscounts.vue?vue&type=style&index=0&id=5f6fced0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports